import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import CustomSelect from "./CustomSelect";
import {
  FilterWrapper,
  FilterLabel
} from "containers/impact-report/index.styled";
import { generateDateRangeOptions } from "utils/optionGenerators";

const DateRangeSelect = ({
  communityRequests,
  selectedRange,
  onRangeChange
}) => {
  const { t } = useTranslation();

  const dateRangeOptions = useMemo(
    () => generateDateRangeOptions(communityRequests),
    [communityRequests]
  );

  const handleChange = useCallback(
    option => {
      onRangeChange(option?.value ?? null);
    },
    [onRangeChange]
  );

  return (
    <FilterWrapper>
      <FilterLabel>
        {t("impactReport.communityRequests.dateRangeLabel")}
      </FilterLabel>
      <CustomSelect
        value={
          dateRangeOptions.find(opt => opt.value === selectedRange) || null
        }
        onChange={handleChange}
        options={dateRangeOptions}
        placeholder={t("impactReport.communityRequests.dateRangePlaceholder")}
        isClearable
        isDisabled={!dateRangeOptions.length}
      />
    </FilterWrapper>
  );
};

DateRangeSelect.propTypes = {
  communityRequests: PropTypes.array.isRequired,
  selectedRange: PropTypes.string,
  onRangeChange: PropTypes.func.isRequired
};

export default DateRangeSelect;
